import {
  BarcodeGenerationType,
  PrintScanBarcodesState,
} from '../types/printScanBarcode';

import {DefaultContext} from '../../utils/types';
import React from 'react';

export const initialState: PrintScanBarcodesState = {
  barcodesPrinting: false,
  barcodesList: [],
  barcodeType: BarcodeGenerationType.system,
  storeBarcodeList: [],
};

const defaultVal: DefaultContext<PrintScanBarcodesState> = {
  state: initialState,
  dispatch: null,
};

export const PrintScanBarcodesContext = React.createContext(defaultVal);
